import { useLocation } from "react-router-dom";

import { useAppBootstrap } from "@/context/AppBootstrapContext";
import { useKaiChatOptional } from "@/features/kai/KaiChatContext";
import { cn } from "@/lib/utils";
import { WaveBackgroundThree } from "./WaveBackgroundThree";

/**
 * Full-viewport backdrop: clean WebGL wave + centre scrim.
 */
export function BackgroundLayer() {
  const kai = useKaiChatOptional();
  const onKaiWelcome = useLocation().pathname === "/" && (kai?.isWelcome ?? true);
  const { phase } = useAppBootstrap();
  const showScrim = phase === "exiting" || phase === "ready";

  return (
    <>
      <WaveBackgroundThree />
      <div
        aria-hidden="true"
        className={cn(
          "bg-scrim pointer-events-none fixed inset-x-0 top-0 -z-10 h-[var(--app-vvh,var(--app-vh,100vh))] w-full transition-opacity duration-700 ease-out",
          showScrim ? "opacity-100" : "opacity-0",
        )}
      />
      <div
        aria-hidden="true"
        className={cn(
          "bg-scrim-content-mask pointer-events-none fixed inset-x-0 top-0 -z-10 h-[var(--app-vvh,var(--app-vh,100vh))] w-full transition-opacity duration-700 ease-out",
          showScrim && !onKaiWelcome && "bg-scrim-content-mask--visible",
        )}
      />
    </>
  );
}
